import { render, staticRenderFns } from "./Talonario.vue?vue&type=template&id=7e8462a4&"
import script from "./Talonario.vue?vue&type=script&lang=js&"
export * from "./Talonario.vue?vue&type=script&lang=js&"
import style0 from "./Talonario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports